<template>
  <div class="renderPage usr-container" :class="{ 'theme--dark': $vuetify.theme.dark }">

    <!-- TOOLBAR CABECERA -->
    <v-toolbar flat height="56" :color="$vuetify.theme.dark ? '#1e293b' : '#f1f5f9'" class="usr-toolbar px-2">
      <v-icon class="mr-2" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-account-multiple-outline</v-icon>
      <v-toolbar-title class="font-weight-black text-uppercase usr-toolbar-title" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-4'">
        Gestión de Usuarios
      </v-toolbar-title>
      <v-spacer />
      <v-btn depressed color="primary" class="usr-btn font-weight-bold" @click="incluir()">
        <v-icon left small>mdi-plus</v-icon> Nuevo Usuario
      </v-btn>
    </v-toolbar>

    <!-- TABLA -->
    <v-card flat class="usr-table-card mx-0" :color="$vuetify.theme.dark ? '#0f172a' : 'white'">
      <v-toolbar flat height="52" :color="$vuetify.theme.dark ? '#0f172a' : 'white'" class="px-3">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar por nombre o cédula..."
          single-line hide-details outlined dense
          class="usr-search"
          style="max-width:420px"
        ></v-text-field>
        <v-spacer />
        <v-btn icon :color="$vuetify.theme.dark ? 'blue-grey lighten-2' : 'grey darken-1'" @click="getData()">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        class="usr-table"
        :items-per-page="25"
        :footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }"
        @click:row="editItem"
        style="cursor:pointer"
      >
        <template v-slot:[`item.cedula`]="{ item }">
          <span class="usr-code-badge">{{ item.cedula }}</span>
        </template>

        <template v-slot:[`item.nombre`]="{ item }">
          <div class="d-flex flex-column py-1">
            <span class="font-weight-bold text-body-2">{{ item.nombre }}</span>
            <span class="caption" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">{{ item.tipo ? 'Administrador' : 'Usuario' }}</span>
          </div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn color="blue-grey darken-2" depressed dark style="min-width:36px;height:36px;padding:0;border-radius:4px" @click.stop="editItem(item)">
            <v-icon size="18">mdi-pencil-outline</v-icon>
          </v-btn>
        </template>

        <template v-slot:no-data>
          <div class="pa-8 text-center">
            <v-icon size="48" :color="$vuetify.theme.dark ? 'blue-grey darken-1' : 'grey lighten-1'" class="mb-3">mdi-account-off-outline</v-icon>
            <p :class="$vuetify.theme.dark ? 'blue-grey--text' : 'grey--text'">No se encontraron usuarios registrados.</p>
            <v-btn color="primary" depressed small @click="getData()">Reintentar</v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- DRAWER FORMULARIO -->
    <v-navigation-drawer v-model="drawerForm" fixed right temporary width="600" class="usr-drawer">
      <div class="d-flex flex-column fill-height">

        <!-- HEADER DRAWER -->
        <div class="usr-drawer-header d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'usr-drawer-header--dark' : ''">
          <v-icon color="white" class="mr-3">{{ editedIndex > -1 ? 'mdi-account-edit' : 'mdi-account-plus' }}</v-icon>
          <div>
            <div class="white--text font-weight-black text-uppercase" style="letter-spacing:1px;font-size:0.95rem;">
              {{ editedIndex > -1 ? 'Editar Usuario' : 'Nuevo Usuario' }}
            </div>
            <div class="caption white--text" style="opacity:0.7">{{ editedItem.cedula || 'SIN CÉDULA' }} · Perfil y accesos de usuario</div>
          </div>
          <v-spacer />
          <v-btn icon dark small @click="cerrar()"><v-icon>mdi-close</v-icon></v-btn>
        </div>

        <!-- FORMULARIO -->
        <div class="flex-grow-1 overflow-y-auto pa-5">
          <v-form ref="form" v-model="valid">

            <!-- DATOS GENERALES -->
            <div class="usr-section-label mb-3">
              <v-icon small class="mr-1" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-account-outline</v-icon>
              <span class="font-weight-black text-caption text-uppercase" style="letter-spacing:1px" :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-3'">Datos Generales</span>
            </div>
            <v-card flat class="usr-section-card pa-4 mb-4">
              <v-row dense>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="editedItem.cedula"
                    label="Cédula"
                    outlined dense
                    prepend-inner-icon="mdi-card-account-details-outline"
                    autocomplete="off"
                    class="usr-readonly-input"
                    :readonly="!incluirValid"
                    @blur="getClienteHacienda"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="editedItem.clave"
                    label="Clave / Password"
                    outlined dense
                    prepend-inner-icon="mdi-lock-outline"
                    type="password"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.nombre"
                    label="Nombre Completo"
                    outlined dense
                    prepend-inner-icon="mdi-account-outline"
                    autocomplete="off"
                    :rules="nameRules"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="8">
                  <v-select
                    v-model="editedItem.ciaPorDefecto"
                    :items="cias"
                    item-text="nombre"
                    item-value="cedula"
                    label="Compañía por Defecto"
                    outlined dense
                    prepend-inner-icon="mdi-office-building-marker-outline"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="4" class="d-flex align-center">
                  <v-checkbox
                    v-model="editedItem.tipo"
                    label="Administrador"
                    class="mt-1"
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card>

            <!-- EXPANSIÓN: COMPAÑÍAS PERMITIDAS -->
            <v-expansion-panels flat class="usr-panels mb-2" v-model="panels">
              <v-expansion-panel class="usr-expansion-panel mb-2">
                <v-expansion-panel-header class="font-weight-bold text-caption text-uppercase" style="letter-spacing:1px;min-height:48px">
                  <div class="d-flex align-center">
                    <v-icon small class="mr-2" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-city-variant-outline</v-icon>
                    <span :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-3'">Compañías Permitidas ({{ companies.length }})</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="d-flex mb-3 pt-2">
                    <v-select
                      v-model="ciaDropDown"
                      :items="cias"
                      item-text="nombre"
                      item-value="cedula"
                      label="Seleccionar Compañía"
                      outlined dense hide-details
                      class="mr-2"
                      @change="changeCia"
                    ></v-select>
                    <v-btn color="primary" depressed class="usr-btn font-weight-bold" height="40" @click="saveCias">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </div>
                  <v-simple-table dense v-if="companies.length > 0" class="usr-simple-table">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>Nombre</th>
                          <th>Cédula</th>
                          <th class="text-center">Quitar</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(cia, index) in companies" :key="index">
                          <td class="font-weight-medium">{{ cia.nombre }}</td>
                          <td><span class="usr-code-badge">{{ cia.cedula }}</span></td>
                          <td class="text-center">
                            <v-btn icon small color="error" @click="deleteItemCias(cia)">
                              <v-icon size="18">mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <p v-else class="caption text-center pa-2" :class="$vuetify.theme.dark ? 'blue-grey--text' : 'grey--text'">
                    Agrega las compañías a las que el usuario tiene acceso.
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- EXPANSIÓN: PERMISOS DE MENÚ -->
              <v-expansion-panel class="usr-expansion-panel">
                <v-expansion-panel-header class="font-weight-bold text-caption text-uppercase" style="letter-spacing:1px;min-height:48px">
                  <div class="d-flex align-center">
                    <v-icon small class="mr-2" :color="$vuetify.theme.dark ? 'teal lighten-2' : 'blue-grey darken-3'">mdi-shield-lock-outline</v-icon>
                    <span :class="$vuetify.theme.dark ? 'white--text' : 'blue-grey--text text--darken-3'">Permisos de Menú ({{ paginas.length }})</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row dense class="pt-2">
                    <v-col cols="12" sm="6">
                      <v-select
                        v-model="menuDropDown"
                        :items="menus"
                        item-text="titulo"
                        item-value="id"
                        label="Menú"
                        outlined dense
                        @change="getMenuOpciones"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-select
                        v-model="menuOpcionesDropDown"
                        :items="menuOpciones"
                        item-text="titulo"
                        item-value="id"
                        label="Página"
                        outlined dense
                        @change="GetMenuOpcion"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-btn color="primary" block depressed class="usr-btn font-weight-bold mb-3" @click="savePaginas">
                    <v-icon left size="16">mdi-plus</v-icon> Agregar Permiso
                  </v-btn>
                  <v-simple-table dense v-if="paginas.length > 0" class="usr-simple-table">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>Módulo</th>
                          <th>Página</th>
                          <th class="text-center">Quitar</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(pag, index) in paginas" :key="index">
                          <td class="font-weight-medium">{{ pag.menuNombre }}</td>
                          <td>{{ pag.titulo }}</td>
                          <td class="text-center">
                            <v-btn icon small color="error" @click="deleteItemPagina(pag)">
                              <v-icon size="18">mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <p v-else class="caption text-center pa-2" :class="$vuetify.theme.dark ? 'blue-grey--text' : 'grey--text'">
                    Agrega los permisos de menú para este usuario.
                  </p>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

          </v-form>
        </div>

        <!-- FOOTER ACCIONES -->
        <div class="usr-drawer-footer d-flex align-center px-4 py-3" :class="$vuetify.theme.dark ? 'usr-drawer-footer--dark' : ''">
          <v-btn v-if="editedIndex > -1" color="error" text class="usr-btn font-weight-bold" @click="deleteItem()">
            <v-icon left small>mdi-trash-can-outline</v-icon> Eliminar
          </v-btn>
          <v-spacer />
          <v-btn text class="mr-3 font-weight-bold usr-btn" @click="cerrar()">Cancelar</v-btn>
          <v-btn color="primary" depressed class="px-8 font-weight-bold usr-btn" :loading="loading" @click="save()">
            {{ editedIndex > -1 ? 'GUARDAR' : 'CREAR USUARIO' }}
          </v-btn>
        </div>
      </div>
    </v-navigation-drawer>

    <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Snackbar from "./shared/Snackbar.vue";

export default {
  components: {
    Snackbar,
  },
  data() {
    return {
      drawerForm: false,
      loading: false,
      valid: false,
      incluirValid: true,
      panels: undefined,
      search: "",
      snackText: "",
      snackValue: false,
      ciaDropDown: "",
      menuDropDown: "",
      menuOpcionesDropDown: "",
      companies: [],
      menus: [],
      menuOpciones: [],
      paginas: [],
      modeloPaginaUsuario: {
        usuario: [],
        companies: [],
        paginas: [],
      },
      headers: [
        { text: "Cédula", value: "cedula", sortable: true },
        { text: "Nombre / Rol", value: "nombre", sortable: true },
        { text: "Acciones", value: "actions", align: 'right', sortable: false },
      ],
      items: [],
      cias: [],
      editedIndex: -1,
      editedItem: {
        id: 0,
        cedula: "",
        clave: "",
        tipo: 0,
        nombre: "",
        ciaPorDefecto: "",
      },
      defaultItem: {
        id: 0,
        cedula: "",
        clave: "",
        tipo: 0,
        nombre: "",
        ciaPorDefecto: "",
      },
      ciaeditedItem: { nombre: "", nombreComercial: "", cedula: "" },
      paginaeditedItem: { id: 0, titulo: "", menuId: 0, path: "", menuNombre: "" },
      nameRules: [(v) => !!v || "El nombre es obligatorio"],
    };
  },

  computed: {
    ...mapGetters(["user", "strCia"]),
  },

  created() {
    this.getData();
    this.getCias();
    this.getMenu();
  },

  methods: {
    getData() {
      let me = this;
      axios.get("api/Usuarios/getUserAll").then(response => {
        me.items = response.data;
      }).catch(error => console.error(error));
    },

    getMenu() {
      let me = this;
      axios.get("api/General/getMenu").then(response => {
        me.menus = response.data;
      }).catch(error => console.error(error));
    },

    getCias() {
      let me = this;
      axios.get("api/Cias/getCias").then(response => {
        me.cias = response.data;
      }).catch(error => console.error(error));
    },

    getMenuOpciones() {
      let me = this;
      axios.get("api/General/getMenuOpciones?menuId=" + this.menuDropDown).then(response => {
        me.menuOpciones = response.data;
      }).catch(error => console.error(error));
    },

    GetMenuOpcion() {
      let me = this;
      axios.get("api/General/getMenuOpcion?id=" + this.menuOpcionesDropDown).then(response => {
        me.paginaeditedItem = response.data;
      }).catch(error => console.error(error));
    },

    getModeloPaginaUsuario() {
      let me = this;
      axios.get("api/Usuarios/getModeloPaginaUsuario?usuarioId=" + this.editedItem.id).then(response => {
        me.modeloPaginaUsuario = response.data;
        me.companies = me.modeloPaginaUsuario.companies;
        me.paginas = me.modeloPaginaUsuario.paginas;
      }).catch(error => console.error(error));
    },

    getClienteHacienda() {
      if (!this.editedItem.cedula) return;
      let me = this;
      axios.get("https://api.hacienda.go.cr/fe/ae?identificacion=" + me.editedItem.cedula).then(response => {
        const data = response.data;
        if (data.nombre) {
          me.editedItem.nombre = data.nombre;
        }
      }).catch(error => console.error("Error Hacienda API:", error));
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.panels = undefined;
      this.getModeloPaginaUsuario();
      this.incluirValid = false;
      this.drawerForm = true;
    },

    incluir() {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.companies = [];
      this.paginas = [];
      this.panels = undefined;
      this.incluirValid = true;
      this.drawerForm = true;
    },

    cerrar() {
      this.drawerForm = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.companies = [];
        this.paginas = [];
      });
    },

    save() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      const me = this;
      const model = {
        usuario: this.editedItem,
        companies: this.companies,
        paginas: this.paginas
      };

      const url = this.editedIndex > -1 ? "api/Usuarios/UpdateModeloPagina" : "api/Usuarios/insertModeloPagina";

      axios.post(url, model).then(() => {
        me.snackText = "Usuario guardado con éxito";
        me.snackValue = true;
        me.getData();
        me.cerrar();
      }).catch(error => {
        console.error(error);
        me.snackText = "Error al guardar el usuario";
        me.snackValue = true;
      }).finally(() => {
        me.loading = false;
      });
    },

    deleteItem() {
      if (!confirm("¿Seguro que deseas eliminar este usuario?")) return;
      let me = this;
      axios.delete("api/Usuarios/deleteUser?usuarioId=" + this.editedItem.id).then(() => {
        me.getData();
        me.cerrar();
      }).catch(error => console.error(error));
    },

    changeCia() {
      let me = this;
      axios.get("api/Cias/getCia?ciaId=" + this.ciaDropDown).then(response => {
        me.ciaeditedItem = response.data;
      });
    },

    saveCias() {
      if (!this.ciaDropDown) return;
      if (this.companies.find(c => c.cedula === this.ciaDropDown)) return;
      this.companies.push(this.ciaeditedItem);
    },

    deleteItemCias(item) {
      const index = this.companies.indexOf(item);
      this.companies.splice(index, 1);
    },

    savePaginas() {
      if (!this.menuOpcionesDropDown) return;
      if (this.paginas.find(p => p.id === this.menuOpcionesDropDown)) return;
      this.paginas.push(this.paginaeditedItem);
    },

    deleteItemPagina(item) {
      const index = this.paginas.indexOf(item);
      this.paginas.splice(index, 1);
    },
  },
};
</script>

<style scoped>
/* ===== CONTAINER ===== */
.usr-container {
  background-color: #f1f5f9;
  min-height: 100vh;
}
.theme--dark.usr-container {
  background-color: #0f172a;
}

/* ===== TOOLBAR ===== */
.usr-toolbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
}
.theme--dark .usr-toolbar {
  border-bottom: 1px solid rgba(255, 255, 255, 0.07) !important;
}
.usr-toolbar-title {
  font-size: 0.95rem !important;
  letter-spacing: 1.5px;
}

/* ===== BUTTONS ===== */
.usr-btn {
  border-radius: 4px !important;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-size: 0.75rem !important;
}

/* ===== TABLE ===== */
.usr-table-card {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
}
.usr-table { background: transparent !important; }
.usr-table >>> thead th {
  background-color: #37474f !important;
  color: #ffffff !important;
  text-transform: uppercase;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.07em;
  border-bottom: none !important;
}
.usr-table >>> tbody tr { cursor: pointer; }
.usr-table >>> tbody tr:hover {
  background-color: rgba(55, 71, 79, 0.05) !important;
}
.theme--dark .usr-table >>> tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

/* ===== CODE BADGE ===== */
.usr-code-badge {
  font-family: monospace;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 2px 6px;
  background: rgba(55, 71, 79, 0.08);
  border-radius: 3px;
  color: #37474f;
}
.theme--dark .usr-code-badge {
  background: rgba(255, 255, 255, 0.1);
  color: #b0bec5;
}

/* ===== SEARCH ===== */
.usr-search >>> .v-input__slot {
  border-radius: 4px !important;
}

/* ===== DRAWER ===== */
.usr-drawer >>> .v-navigation-drawer__content {
  background-color: #ffffff !important;
}
.theme--dark .usr-drawer >>> .v-navigation-drawer__content {
  background-color: #0f172a !important;
}

/* ===== DRAWER HEADER ===== */
.usr-drawer-header {
  background-color: #37474f;
  flex-shrink: 0;
}
.usr-drawer-header--dark {
  background-color: #263238 !important;
}

/* ===== DRAWER FOOTER ===== */
.usr-drawer-footer {
  background-color: #f8fafc;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
}
.usr-drawer-footer--dark {
  background-color: #1e293b !important;
  border-top: 1px solid rgba(255, 255, 255, 0.07) !important;
}

/* ===== SECTION LABEL ===== */
.usr-section-label {
  display: flex;
  align-items: center;
}

/* ===== SECTION CARD ===== */
.usr-section-card {
  border: 1px solid rgba(0, 0, 0, 0.07) !important;
  border-radius: 4px !important;
  background-color: #ffffff !important;
}
.theme--dark .usr-section-card {
  border-color: rgba(255, 255, 255, 0.07) !important;
  background-color: #1e293b !important;
}

/* ===== READONLY INPUT ===== */
.usr-readonly-input >>> .v-input__slot {
  background-color: rgba(0, 0, 0, 0.03) !important;
}
.theme--dark .usr-readonly-input >>> .v-input__slot {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

/* ===== EXPANSION PANELS ===== */
.usr-panels {
  border: 1px solid rgba(0, 0, 0, 0.07) !important;
  border-radius: 4px !important;
  overflow: hidden;
}
.theme--dark .usr-panels {
  border-color: rgba(255, 255, 255, 0.07) !important;
}
.usr-expansion-panel {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
}
.usr-expansion-panel:last-child {
  border-bottom: none !important;
}
.theme--dark .usr-expansion-panel {
  border-bottom-color: rgba(255, 255, 255, 0.05) !important;
}
.usr-panels >>> .v-expansion-panel {
  background-color: #ffffff !important;
}
.theme--dark .usr-panels >>> .v-expansion-panel {
  background-color: #1e293b !important;
}

/* ===== SIMPLE TABLE ===== */
.usr-simple-table >>> thead th {
  background-color: #37474f !important;
  color: #ffffff !important;
  text-transform: uppercase;
  font-size: 0.7rem !important;
  font-weight: 700 !important;
  letter-spacing: 0.07em;
}
</style>